import { fetchFamilyActivities } from '@/services/get-family-activities';
import { useQuery } from '@tanstack/react-query';

export const familyActivitiesKeys = {
  all: ['family-activities'] as const,
  list: (guardianId?: string) => [...familyActivitiesKeys.all, guardianId ?? null] as const,
};

/**
 * Signed-in guardian's family activity feed from `GET /api/v1/guardians/me/activities`
 * (newest first). Pass the auth `uid` to key the cache + gate the request on being
 * signed in.
 */
export function useFamilyActivitiesQuery(guardianId?: string) {
  return useQuery({
    queryKey: familyActivitiesKeys.list(guardianId),
    queryFn: () => fetchFamilyActivities(),
    enabled: Boolean(guardianId),
  });
}
